<template>
  <div class="details">
    <!-- 详情页 -->
    <div class="details_content">
      <div class="details_content_title">
        <QS-h3-title class="purchase" :title="titledetails"></QS-h3-title>
      </div>
      <commonBaseInfo v-if="orderType === 'personal'" :orderId="orderId"/>
      <el-tabs v-model="theOrder" class="TapTabs">
        <el-tab-pane
          v-for="(item, index) in theOrderList"
          :key="'theOrderList' + index"
          :name="item.name"
          :label="item.label"
        ></el-tab-pane>
      </el-tabs>
      <div v-if="theOrder === '0'">
        <!-- 订单信息 -->
        <OrderInformation v-loading="oLoading.search" :orderId="orderId" />
      </div>
      <div v-if="theOrder === '1'">
        <!-- 收付款信息 -->
        <Receiptandpayment />
      </div>
      <div v-if="theOrder === '2'">
        <!-- 支付计划 -->
        <PaymentPlan :orderId="orderId" />
      </div>
      <div v-if="theOrder === '3'">
        <!-- 出入库记录 -->
        <StockInOuRecord :orderId="orderId" />
      </div>
      <div v-if="theOrder === '4'">
        <!-- 订单关联信息 -->
        <OrderRelated />
      </div>
      <div v-if="theOrder === '5'">
        <ReturnInformation
          :orderId="orderId"
          :orderState="orderState"
          :newCalculationOpenSwitch="newCalculationOpenSwitch"
        />
      </div>
      <div v-if="theOrder === '6'">
        <!-- 合同签署记录 -->
        <ConSigningRecord :orderId="orderId" :rentCategory="rentCategory" />
      </div>
      <div v-if="theOrder === '8'">
        <!-- 司机账单 -->
        <driversbill :orderId="orderId" :rentCategory="rentCategory"  />
      </div>
      <div v-if="theOrder === '9' && rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI">
        <!-- 结算记录 只有司机合作模式展示 -->
        <settlementRecord :orderId="orderId" />
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import {
  leaseContractOrderDetail,
} from '@/api/purchaseAndSaleAPI'
import { checkLeasePlanCalculateOpen } from '@/api/domain/others'
import OrderInformation from '@/pages/orders/personalOrder/components/orderDetail.vue'
import Receiptandpayment from './components/ReceiptAndPayment/index.vue'
import PaymentPlan from './components/PaymentPlan'
import StockInOuRecord from './components/StockInOuRecord.vue'
import OrderRelated from './components/OrderRelated.vue'
import ReturnInformation from './components/returnInformation.vue'
import ConSigningRecord from '@/pages/orders/components/conSigningRecord/index.vue'
import { TEMPLATE_STATE_MAP } from '@/store/dict/templateDict'
import commonBaseInfo from '@/pages/orders/personalOrder/components/commonBaseInfo.vue'
import driversbill from '@/pages/orders/components/driversbill/index.vue'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict'
import settlementRecord from '@/pages/orders/components/settlementRecord/index.vue'


export default {
  components: {
    OrderInformation,
    Receiptandpayment,
    PaymentPlan,
    StockInOuRecord,
    OrderRelated,
    ReturnInformation,
    ConSigningRecord,
    commonBaseInfo,
    driversbill,
    settlementRecord,
  },
  data() {
    return {
      orderType: '', // 用来区分是个人租赁订单详情还是企业租赁子订单详情 - 【personal】表示个人租赁订单;【enterChild】表示企业租赁子订单
      orderState: '',
      oLoading: {
        search: false,
      },
      theOrder: 0,
      // 展示退车信息type
      returnInfoType: 0,
      orderData: {
      },
      theOrderList: [],
      personalList: [
        {
          label: '订单信息',
          name: '0',
        },
        {
          label: '司机账单',
          name: '8',
        },
        {
          label: '出入库记录',
          name: '3',
        },
        {
          label: '订单关联信息',
          name: '4',
        },
        {
          label: '退车信息',
          name: '5',
        },
        {
          label: '合同签署记录',
          name: '6',
        },
      ],
      enterChildList: [
        {
          label: '订单信息',
          name: '0',
        },
        {
          label: '收付款信息',
          name: '1',
        },
        {
          label: '支付计划',
          name: '2',
        },
        {
          label: '出入库记录',
          name: '3',
        },
        {
          label: '订单关联信息',
          name: '4',
        },
        {
          label: '退车信息',
          name: '5',
        },
      ],
      // 通过来源获取详情信息
      detailBySource: {
        personal: {
          tabs: 'all', // 全部展示
          title: '租赁订单详情',
          detailApi: leaseContractOrderDetail,
        },
        enterChild: {
          tabs: [0, 1, 2, 3, 4, 5],
          title: '企业租赁子订单详情',
          detailApi: leaseContractOrderDetail,
        },
      },
      rentCategory: '',
      CATEGORY_CODE_MAP,
      newCalculationOpenSwitch: true,
    }
  },
  provide() {
    return {
      orderData: this.orderData,
      getDetails: this.getDetails,
    }
  },
  created() {
    const { id } = this.$route.query
    const orderType = this.$route.query.orderType || 'personal'
    this.orderType = orderType
    // 根据订单类型判断订单详情需要渲染的的tabs
    this.theOrderList = this.getTabs()
    if (id || id === 0) {
      this.orderId = id
    } else {
      this.$message.error('缺少ID参数')
      this.$router.go(-1)
      return
    }
    this.getDetails()
    // type 对应展示哪一个Tab
    const typecar = this.$route.query.type
    // 退车信息title展示
    this.returnInfoType = this.$route.query.returnInfoType || 0
    if (typecar === undefined) {
      this.theOrder = '0'
    } else {
      this.theOrder = String(typecar)
    }
    this.theOrder = String(this.theOrder)
    this.getNewCalculationOpenSwitch()
  },
  computed: {
    titledetails() {
      const a = this.detailBySource[this.orderType].title
      if (this.theOrder === '5') {
        if (Number(this.returnInfoType) === 2) {
          return '发起退车解约'
        } else if (Number(this.returnInfoType) === 1) {
          return '核算确认'
        } else {
          return a
        }
      } else {
        if (this.theOrder === '0') {
          if (Number(this.$route.query.confirm) === 1) {
            return '租赁订单确认'
          } else {
            return a
          }
        }
        return a
      }
    },
  },
  methods: {
    // 详情页请求数据
    async getDetails() {
      const { detailApi } = this.detailBySource[this.orderType]
      try {
        this.oLoading.search = true
        const { code, data } = await detailApi({
          orderId: this.orderId,
        })
        this.oLoading.search = false
        if (code === 1) {
          this.rentCategory = data.rentCategory
          this.orderState = data.state
          const st = data.presentStartDate || ''
          const et = data.presentEntDate || ''
          if (st && et) {
            this.$set(this.orderData, 'freeCycle', `${st}~${et}`)
          } else {
            this.$set(this.orderData, 'freeCycle', '')
          }
          this.$set(this.orderData, 'orderId', this.orderId)
          this.$set(this.orderData, 'orderType', this.orderType) // 订单类型
          if (data.templateName && data.templateState === TEMPLATE_STATE_MAP.JIN_YONG) {
            data.templateName += '(禁用)'
          }
          // 因为是引用类型，所以动态添加key
          if (data && Object.keys(data).length) {
            Object.keys(data).forEach((key) => {
              this.$set(this.orderData, key, data[key], '--')
            })
          }
        }
      } catch (error) {
        this.oLoading.search = false
      }
    },
    // 获取不同订单类型需要渲染的tab
    getTabs() {
      this.theOrderList = this.orderType === 'personal' ? this.personalList : this.enterChildList
      const arr = []
      const { tabs } = this.detailBySource[this.orderType]
      // tabs里没有对应的key则返回全部tab
      if (tabs === 'all') {
        return this.theOrderList
      }
      // tabs有对应的key则返回对应tabs
      this.theOrderList.forEach((item) => {
        tabs.includes(Number(item.name)) && arr.push(item)
      })
      return arr
    },
    async getNewCalculationOpenSwitch() {
      const { code, data } = await checkLeasePlanCalculateOpen({
        orderId: this.orderId,
      })
      if (code === 1) {
        this.newCalculationOpenSwitch = data
      }
    },
  },
  watch: {
    rentCategory: {
      handler(val) {
        if (this.orderType === 'personal' && val === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
          this.theOrderList.splice(1, 0, {
            label: '结算记录',
            name: '9',
          })
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.details {
  .details_content {
    .details_content_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .purchase {
        margin: 0;
      }
      h3 {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #323233;
        font-weight: 500;
        margin: 0;
      }
    }
    .details_content_repeat {
      margin-bottom: 16px;
      ::v-deep .qs-h4-container-left {
        font-size: 16px;
      }
      .details_content_repeat_hundred {
        ::v-deep .column-title {
          text-align: right;
          padding-right: 10px;
          color: #333333;
          min-width: 115px !important;
        }
        .enclosure {
          ::v-deep .el-form-item__label {
            width: 140px !important;
          }
        }
      }
    }
    // 文件图标颜色
    .uptext {
      .blue {
        color: #2e7eff;
        display: inline-block;
        margin: 0;
      }
    }
  }
}
.TapTabs {
  margin-top: 20px;
}
</style>
